


















/**
* Create componets based on the card type.
*/
import Vue from 'vue';
import Vuex from 'vuex';
import * as _ from 'lodash';
import { Component, Prop } from "vue-property-decorator";
import FormComponents from "./CardType/Form/Form.vue";
import FormGroupsComponents from "./CardType/Form/FormGroups/FormGroups.vue";
import DataTableComponents from "./CardType/DataTable/DataTable.vue";
import FormLabelLeftComponents from "./CardType/FormLabelLeft/FormLabelLeft.vue";
import FormLabelRightComponents from "./CardType/FormLabelRight/FormLabelRight.vue";
import TreeTableComponents from "./CardType/TreeTable/TreeTable.vue";

/*
      * Component's properties and events
*/
@Component({
    components: {
        FormComponents,
        FormGroupsComponents,
        DataTableComponents,
        FormLabelLeftComponents,
        FormLabelRightComponents,
        TreeTableComponents
    }
})

export default class HeaderComponent extends Vue {
    /*
         * Component's variables
    */
    private  dialog: boolean = false;
    private editedItem: any = {};
    private editedIndex: number = -1;

    /*
          *  A component�s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
    */
    data() {
        // @ts-ignore
        let payload = this.$store.state[this.$options.parent.fileName];
        payload.orgFields = payload.fields;
        return payload;
    }

    //#. The mounted() method gives you access to templates and enables interaction with the DOM.
    mounted() {
        // @ts-ignore
        this.$store.dispatch('load', this.$store.state[this.$options.parent.fileName]);
    }

    /**
      * Dynamically re-render title based on the page change.
    */
    renderTitle(perPage) {
        // @ts-ignore
        let id = $(this.$el.parentElement).parent().attr('id');
        id = id.charAt(0).toLowerCase() + id.slice(1).replace('Component', '');
        let title = this.$store.state[id].orginTitle;

        if (_.includes(title, '{{')) {
            title = title.substr(2).slice(0, -2);
            this.$store.state[id].title = this.$store.state[id].formData[perPage - 1][title];
        }
    }

    //#. Add new records
    add() {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName], field = null;
        context.buttonDisabled = false;

        if (context.redirect) {
            window.location.href = context.redirect.action + '?mId=' + context.redirect.menuId + '#' + 0;
            return;
        }

        //#. Create form event - reset properties
        if (!context.parentComponent && context.dashboard.componentId == 0) {
            context.dashboard.snackbar = true;
            context.dashboard.color = context.notyTypes.error;
            context.dashboard.text = context.messages.cardFill;
            return;
        }

        this.dialog = true;
        this.editedItem = Object.assign({}, context.defaultItem);

        if (context.permissions.indexOf('A') != -1) {
            context.disabled = false;
        }

        context.formEdit = true;
        context.formCreate = true;
        this.editedIndex = -1;
        // @ts-ignore
        this.$store.dispatch(context.fileName + '/formCreated', context);

        //#. find first editable field
        field = context.fields.filter(x => x.primaryKey != true && x.readonly != true && x.parent != true && x.create != false).find(x => x).value;

        setTimeout(() => {
            // @ts-ignore
            this.$parent.$children[0].$refs[field][0].$refs[field].focus();
        }, 100);
    }        
};
